import { default as minify } from "minify-fast";
import { t } from "@/i18n-js/instance";
import type { useToast } from "@circle-react-uikit/ToastV2";
import copyToClipboard from "copy-to-clipboard";

interface CopyEmbedCodeProps {
  embedCodeRef: React.RefObject<HTMLDivElement>;
  embedCodeText: string;
  toast: ReturnType<typeof useToast>;
}
const i18nRoot = "settings.forms.edit.embed";

export const copyEmbedCode = ({
  embedCodeRef,
  embedCodeText,
  toast,
}: CopyEmbedCodeProps) => {
  if (!embedCodeRef.current) return;

  window.getSelection()?.selectAllChildren(embedCodeRef.current);

  if (copyToClipboard(embedCodeText)) {
    toast.success(t([i18nRoot, "copy_success"]), {
      duration: "short",
      shouldUseProgress: false,
    });
  } else {
    toast.error(t([i18nRoot, "copy_error"]));
  }
};

interface EmbedCodeProps {
  currentCommunityFullUrl: string;
  formUid: string;
  isPopup: boolean;
  isPreview?: boolean;
  isUsedOnPages?: boolean;
  popupDelay?: string;
  popupFrequency?: string;
}
export const embedCode = function ({
  formUid,
  isPopup,
  currentCommunityFullUrl,
  isPreview = false,
  isUsedOnPages = false,
  popupDelay,
  popupFrequency,
}: EmbedCodeProps) {
  const code = `
    if (!window.circleFormsScriptLoaded) {
      window.circleFormsScriptLoaded = true;
      const script = document.createElement('script');
      script.src = '${currentCommunityFullUrl}external/form-embeds.js';
      script.defer = true;
      document.head.appendChild(script);
    }
  `;
  return `<div data-is-popup="${isPopup}" data-circle-form-uid="${formUid}" ${extraParams(isPreview, isUsedOnPages, isPopup, popupDelay, popupFrequency)}></div>
          <script>${minify({ code })}</script>`;
};

const extraParams = (
  isPreview: boolean,
  isUsedOnPages: boolean,
  isPopup: boolean,
  popupDelay?: string,
  popupFrequency?: string,
) => {
  let params = "";

  if (isPreview) {
    params += `data-is-preview="${isPreview}"`;
  }
  if (isUsedOnPages) {
    params += ` data-is-used-on-pages="${isUsedOnPages}"`;
  }
  if (isPopup) {
    params += ` data-popup-frequency="${popupFrequency}" data-popup-delay="${popupDelay}"`;
  }
  return params;
};
